import { css } from "@/utils/css";
import { formatTime } from "@/utils/format";
import { __ } from "@wordpress/i18n";
import { v4 as uuid } from "uuid";

type Time = {
    hour: number;
    minute: number;
};

type Props = {
    label?: string;
    help?: string;
    value?: Time;
    onChange?: (value: Time) => void;
    className?: string;
};

export function TimeInput({ label, help, value, onChange, className }: Props) {
    const id = uuid();

    return (
        <label className={css("time-input", className || "")} htmlFor={id}>
            <span className={css("form-label")}>{label}</span>
            <input
                id={id}
                type="time"
                className={css("form-input")}
                value={formatTime(value?.hour || 0, value?.minute || 0, "HH:mm")}
                onChange={(e) => {
                    const [hour, minute] = e.target.value.split(":").map(Number);
                    onChange?.({ hour, minute });
                }}
            />
            {help && <p className={css("form-help")}>{help}</p>}
        </label>
    );
}
